import { ref } from 'vue'

// O Header da Dashboard é montado duas vezes (toolbar mobile + desktop, só escondidas por CSS) e
// cada cópia teleporta o modal de filtros para #app: eram 2 modais empilhados na mesma posição, e o
// de baixo não recebia clique. Só a primeira instância viva renderiza o modal. O estado fica neste
// módulo (e não num segundo <script> do .vue) para o componente manter o export default tipado.
const renderOwners = ref<number[]>([])
let nextInstanceId = 0

export const claimFilterModalRender = () => {
  const instanceId = ++nextInstanceId
  renderOwners.value = [...renderOwners.value, instanceId]
  return {
    isOwner: () => renderOwners.value[0] === instanceId,
    release: () => {
      renderOwners.value = renderOwners.value.filter((id) => id !== instanceId)
    }
  }
}
